
export default {
  props: {
    app: {},
    showLabel: {
      default: true
    },
    isLink: {
      default: true
    }
  }
};
